import { render, staticRenderFns } from "./weekDayCommentOnly.vue?vue&type=template&id=9899a2fa"
import script from "./weekDayCommentOnly.vue?vue&type=script&lang=js"
export * from "./weekDayCommentOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports